export const TEST_ID = {
    CHALLENGE_NEW_PASSWORD_REQUIRED_PAGE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_PAGE',
    CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_NAME: 'CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_NAME',
    CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_PHONE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_PHONE',
    CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_PASSWORD: 'CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_PASSWORD',
    CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_CONFIRM_PASSWORD: 'CHALLENGE_NEW_PASSWORD_REQUIRED_INPUT_CONFIRM_PASSWORD',
    CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMIT_BUTTON: 'CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMIT_BUTTON',
    CHALLENGE_NEW_PASSWORD_REQUIRED_PHONE_ERROR_MESSAGE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_PHONE_ERROR_MESSAGE',
    CHALLENGE_NEW_PASSWORD_NAME_ERROR_MESSAGE: 'CHALLENGE_NEW_PASSWORD_NAME_ERROR_MESSAGE',
    CHALLENGE_NEW_PASSWORD_REQUIRED_PASSWORD_ERROR_MESSAGE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_PASSWORD_ERROR_MESSAGE',
    CHALLENGE_NEW_PASSWORD_REQUIRED_CONFIRM_PASSWORD_ERROR_MESSAGE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_CONFIRM_PASSWORD_ERROR_MESSAGE',
};
